import { render, staticRenderFns } from "./SubmitSetting.vue?vue&type=template&id=e9912cfc&scoped=true&"
import script from "./SubmitSetting.vue?vue&type=script&lang=js&"
export * from "./SubmitSetting.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSetting.vue?vue&type=style&index=0&id=e9912cfc&prod&lang=less&scoped=true&"
import style1 from "./SubmitSetting.vue?vue&type=style&index=1&id=e9912cfc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9912cfc",
  null
  
)

export default component.exports